export default __webpack_public_path__ + "ba1af58ba60306aabb2d032e7f3bf7b4.mp4";